import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { ModalContent, ModalHeader, Portal } from 'fronton-react';
import { Modal } from 'fronton-react/modal';
import { useTranslation } from 'react-i18next';
import { useBreakpoints } from 'common/hooks';
import { modalContainer, modalContent, modalCustom } from './styles';
import { ProductReturnsModalContent } from './product-returns-modal-content';

export const DATA_QA_PRODUCT_RETURNS_NEW_MODAL_CONTENT = 'product-returns-new-modal-content';

type Props = {
  modalVisibility: boolean;
  setModalVisibility: Dispatch<SetStateAction<boolean>>;
};

export const ProductReturnsModal: React.FC<Props> = ({ modalVisibility, setModalVisibility }) => {
  const { t } = useTranslation();
  const { mobile, tablet, desktop, largeDesktop } = useBreakpoints() || {
    mobile: false,
    tablet: false,
    desktop: false,
    largeDesktop: false,
  };
  const modalSize = useMemo(() => {
    if (largeDesktop || desktop) return 'l';
    if (tablet) return 'm';
    if (mobile) return 's';
    return 'm';
  }, [desktop, largeDesktop, mobile, tablet]);

  return (
    <div
      className={modalContainer}
      data-qa="product-returns-new-modal"
      aria-label={t('product-returns.modal.title')}
    >
      <Portal>
        <Modal
          show={modalVisibility}
          modalID="product-returns-new"
          className={modalCustom}
          onClose={() => setModalVisibility(false)}
          size={modalSize}
          variant="curtain"
        >
          <ModalHeader title={t('product-returns.modal.title')} color="text-primary" />
          <ModalContent className={modalContent} data-qa={DATA_QA_PRODUCT_RETURNS_NEW_MODAL_CONTENT}>
            <ProductReturnsModalContent />
          </ModalContent>
        </Modal>
      </Portal>
    </div>
  );
};
